module.exports = __webpack_public_path__ + "media/components/assets/bottle_icon_03-94fe09c0edff3fdf8e6629864a3e4b22.png";